module.exports = __webpack_public_path__ + "img/calendar.2a0bcb75.svg";